<template>
  <!-- :no-filter="filterLookup" -->
  <v-autocomplete
    :label="propLabel"
    v-bind="$attrs"
    filled
    item-text="DisplayText"
    hide-no-data
    item-value="ID"
    v-on="$listeners"
  >
    <slot
      v-for="(_, slot) of $slots"
      :slot="slot"
      :name="slot"
    />
    <template
      v-for="(_, slot) of $scopedSlots"
      :slot="slot"
      slot-scope="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <template #append>
      <v-icon
        v-if="model && model.__proxy__ && model.__proxy__.isDirty(def.name)"
        @click="model && model.__proxy__ && model.__proxy__.undo(def.name)"
      >
        mdi-undo
      </v-icon>  
    </template>
    <template #prepend-inner>
      <AppToolTip
        v-if="def && def.help"
        :def="def.help"
      ></AppToolTip>
    </template>
    <template #label>
      <div>
        {{ propLabel }}<span
          v-if="def && def.kind === 'TFormProp' && def.required"
          class="red--text font-weight-bold"
        > *</span>
      </div>
    </template>
    <template
      v-if="def.lookup && def.lookup.searchConfig && def.lookup.searchConfig.advancedSearch"
      #append-outer
    >
      <AppSelectInto
        :def="{ prop: def, ...def.lookup.searchConfig }"
        :model="model"
      />
    </template>
  </v-autocomplete>
</template>

<script>
import AppToolTip from "@/components/library/common/AppToolTip";
export default {
  name: "AppAutoComplete",
  components: { AppToolTip },
  props: ["def" , "model"],
  computed: {
    propLabel() {
      let label = this.$t(this.def);
      return label;
    },
    // filterLookup(){
    //   if(this.def.lookup.lookupMethod?.name ===
    //         "ECore.Def.DefEnums.lmServerAutoComplete"){
    //           return true;
    //         }
    //   return false;
    // }
  },
};
</script>
